import { StateReducers } from 'state/reducers/types/StateReducers'
import { RoleTypes } from 'firebaseFunctions/types'
import { getCustomClaimTeamRole } from './getCustomClaimTeamRole'

interface Props {
  state: StateReducers
  teamId?: string
}

export const getCanOwn = ({ state, teamId }: Props): boolean => {
  const role = getCustomClaimTeamRole({ state, teamId })

  return role === RoleTypes.Owner
}
